import { autoserializeAs, autoserializeAsArray } from 'dcerialize';

import { RestItemList } from './rest-item';

export class HelpCenter {
  /**
   * Title content
   */
  @autoserializeAs(() => Number) _id: number;

  /**
   * Front display name
   */
  @autoserializeAs(() => String) displayName: string;

  /**
   * Option name
   */
  @autoserializeAs(() => String) optionName: string;

  /**
   * Whether the setting is enabled
   */
  @autoserializeAs(() => Boolean) enabled: boolean;

  /**
   *
   * @param _id setting id
   * @param displayName Front display name
   * @param optionName Option name
   * @param enabled Whether the setting is enabled
   */
  constructor(_id: number, displayName: string, optionName: string, enabled: boolean) {
    this._id = _id;
    this.displayName = displayName;
    this.optionName = optionName;
    this.enabled = enabled;
  }
}

export class HelpCenterList extends RestItemList<HelpCenter> {
  /**
   * Help center list
   */
  @autoserializeAsArray(() => HelpCenter) items: HelpCenter[];

  /**
   * Number of items
   */
  @autoserializeAs(() => Number) total: number;

  constructor(items: HelpCenter[] = [], total = 0) {
    super();
    this.items = items;
    this.total = total;
  }
}
